import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "sidebarLink"]
  
  declare readonly contentTarget: HTMLElement
  declare readonly hasContentTarget: boolean
  declare readonly sidebarLinkTargets: HTMLElement[]

  select(event: Event) {
    event.preventDefault()
    const url = (event.currentTarget as HTMLAnchorElement).href
    
    // Update active state in sidebar
    this.sidebarLinkTargets.forEach(link => {
      link.classList.remove('text-primary', 'bg-primary/10', 'border-l-4', 'border-primary', 'font-bold')
      link.classList.add('text-on-surface-variant', 'hover:text-primary', 'hover:bg-surface-container')
    })
    
    const currentLink = event.currentTarget as HTMLElement
    currentLink.classList.add('text-primary', 'bg-primary/10', 'border-l-4', 'border-primary', 'font-bold')
    currentLink.classList.remove('text-on-surface-variant', 'hover:text-primary', 'hover:bg-surface-container')

    // Use Turbo to fetch the new content
    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
      }
    })
    .then(response => response.text())
    .then(html => {
      // In a real Rails app, this would be a Turbo Stream response
      // For this demo, we'll just replace the inner content
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const newContent = doc.querySelector('#car-details')
      if (newContent && this.hasContentTarget) {
        this.contentTarget.innerHTML = newContent.innerHTML
        // Scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    })
  }
}
